export default __webpack_public_path__ + "static/media/3-Commerce.3a2dea8c.jpeg";